import { lazy } from '@loadable/component';

const QueueDashboardPage = lazy(() => import('./QueueDashboard'));

export default QueueDashboardPage;
